import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoArmas: [],
  },

  getters: {
    getTipoArmas: (state) => state.tipoArmas,
  },

  mutations: {
    SET_TIPO_ARMAS: (state, tipoArmas) => {
      state.tipoArmas = tipoArmas;
    },
  },

  actions: {
    async fetchTiposArma({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/Armeria/tipoArma/')
        .then((response) => {
          commit('SET_TIPO_ARMAS', response.data.data);
        });
    },
  },
};
